import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, debounce, Options} from "../utils/decorators";


@Options({
    template: false,
    ui: {
        dropdownToggle:      "[data-js-ui=footer-dropdown-toggle]",
    }
})
export default class SiteFooterView extends Marionette.View<Backbone.Model>{

    @on("click @ui.dropdownToggle")
    onDropdownToggleClick(e) {
        const maxDropdownWidth = 992;
        let $target = $(e.currentTarget);
        let windowWidth = $(window).width();
        if (windowWidth < maxDropdownWidth ) {
            $target.next('[data-js-ui=footer-dropdown]').slideToggle();
            $target.find('[data-js-ui=footer-dropdown-icon]').toggleClass("is-expanded");
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/site-footer-view.ts